import { zodResolver } from '@hookform/resolvers/zod'
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@material-ui/core'
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import Button from '@/components/button'

import { useStyles } from './style'

const decisionSchema = z.object({
  accept: z.literal(true),
})

type DecisionSchema = z.infer<typeof decisionSchema>

interface AcceptanceTermModalProps {
  open: boolean
  onClose?: () => void
  onSubmit?: () => void
  isLoading?: boolean
}

export function AcceptanceTermModal({
  open,
  onClose,
  onSubmit,
  isLoading,
}: AcceptanceTermModalProps) {
  const classes = useStyles()

  const { handleSubmit, register } = useForm<DecisionSchema>({
    resolver: zodResolver(decisionSchema),
  })

  function onSubmitForm() {
    onSubmit?.()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.main,
      }}
      PaperProps={{
        component: 'form',
        onSubmit: handleSubmit(onSubmitForm),
      }}
    >
      <DialogTitle disableTypography classes={{ root: classes.dialogTitle }}>
        <CheckCircleOutlineOutlinedIcon />
        <Typography variant={'h2'}>Seguir com o diagnóstico</Typography>
      </DialogTitle>
      <DialogContent
        classes={{
          root: classes.dialogContent,
        }}
      >
        <ul>
          <Typography component={'li'}>
            Declaro que os arquivos enviados estão corretos e de acordo com a
            minha solicitação.
          </Typography>
          <Typography component={'li'}>
            Autorizo a realização do diagnóstico, mesmo após o reporte de não
            conformidade, ciente de que o ortomosaico apresenta trechos com
            qualidade comprometida (como borrões ou variações de iluminação), e
            compreendo que isso poderá impactar a precisão dos resultados
            obtidos.
          </Typography>
          <Typography component={'li'}>
            Estou ciente e autorizo que todas as áreas delimitadas pelo
            perímetro de interesse sejam analisadas e descontadas do meu pacote
            Cromai, independentemente das condições identificadas no
            ortomosaico.
          </Typography>
        </ul>

        <FormControlLabel
          control={<Checkbox {...register('accept')} />}
          label='Declaro que li e estou de acordo com os termos acima'
        />
      </DialogContent>
      <DialogActions
        classes={{
          root: classes.dialogActions,
        }}
      >
        <Button onClick={onClose} outlined disabled={isLoading}>
          Cancelar
        </Button>

        <Button type='submit' disabled={isLoading}>
          Seguir com diagnóstico
        </Button>
      </DialogActions>
    </Dialog>
  )
}
